import { l } from "../core/i18n.js";
import { t } from "../core/i18n.js";
import { navItems } from "../core/config.js";
import { runtime } from "../core/runtime.js";
import { WORKSPACE_ROUTES } from "../../shared/seo.js";
import { updatePageMetadata } from "../core/seo.js";
export const routes = WORKSPACE_ROUTES;
export function syncRoute() {
  const home = document.body.dataset.presentation === "home";
  const auth = document.body.dataset.presentation === "auth";
  const next = auth ? location.pathname : home ? "/" : "/" + runtime.page;
  if (location.pathname !== next) history.pushState({}, "", next);
  const pageTitle =
    "DayX · " +
    t(
      auth
        ? {
            "/signup": l("Sign up"),
            "/forgot-password": l("Reset password"),
            "/reset-password": l("Reset password"),
            "/verify-email": l("Confirm email"),
          }[location.pathname] || l("Log in")
        : home
          ? l("Less noise. More focus.")
          : navItems.find(([id]) => id === runtime.page)?.[1] || l("Workspace"),
    );
  updatePageMetadata(pageTitle);
  document.querySelectorAll(".switch").forEach((button) => {
    button.setAttribute("role", "switch");
    button.setAttribute(
      "aria-checked",
      String(button.classList.contains("on")),
    );
    if (!button.getAttribute("aria-label"))
      button.setAttribute(
        "aria-label",
        button.closest(".toggle-row")?.querySelector("span")?.textContent ||
          l("Toggle preference"),
      );
  });
  document
    .querySelectorAll("[data-page]")
    .forEach((button) =>
      button.setAttribute(
        "aria-current",
        button.dataset.page === runtime.page ? "page" : "false",
      ),
    );
}
export function bindAccessibility() {
  const modalHost = document.getElementById("modal");
  let returnFocus;
  const observer = new MutationObserver(() => {
    const modal = modalHost.querySelector(".modal");
    if (!modal || !modalHost.classList.contains("show")) {
      document.querySelector(".app").inert = false;
      document.querySelector("#mobileNav").inert = false;
      document.querySelector("#studyWidget").inert = false;
      if (returnFocus?.isConnected) returnFocus.focus();
      returnFocus = null;
      return;
    }
    if (modal.dataset.enhanced === "true") return;
    modal.dataset.enhanced = "true";
    returnFocus ||= document.activeElement;
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    const title = modal.querySelector("h2");
    if (title) {
      title.id = "dialogTitle";
      modal.setAttribute("aria-labelledby", title.id);
    }
    modal.querySelectorAll("label").forEach((label) => {
      if (label.htmlFor) return;
      const field = label.nextElementSibling;
      if (field?.matches("input, select, textarea") && field.id)
        label.htmlFor = field.id;
    });
    // Finish the entrance motion before making its composited subtree inert.
    // Otherwise Chromium can retain inert hit-testing after the modal closes.
    document
      .getElementById("appPage")
      .getAnimations()
      .forEach((animation) => animation.cancel());
    document.querySelector(".app").inert = true;
    document.querySelector("#mobileNav").inert = true;
    document.querySelector("#studyWidget").inert = true;
    modal
      .querySelector("input:not([type=checkbox]), select, textarea, button")
      ?.focus();
  });
  observer.observe(modalHost, {
    childList: true,
    attributes: true,
    attributeFilter: ["class"],
  });
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Tab" || !modalHost.classList.contains("show")) return;
    const fields = [
      ...modalHost.querySelectorAll("button, input, select, textarea, a[href]"),
    ].filter((el) => !el.disabled && el.getClientRects().length);
    const first = fields[0],
      last = fields.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
}
